import React from 'react';

import PropTypes from 'prop-types';

// eslint-disable-next-line no-unused-vars
import { TransactionState } from './ManualPaymentTypes';

class ManualPaymentErrorDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      detailsShown: false,
    };

    this.showErrorDetails = this.showErrorDetails.bind(this);
  }

  /**
   * Handles showing error details.
   */
  showErrorDetails() {
    this.setState(() => ({
      detailsShown: true,
    }));
  }

  render() {
    const { error } = this.props;
    const { detailsShown } = this.state;

    return (
      <div className="quick-pay-modal__body__error">
        {!detailsShown && (
          <button
            type="button"
            className="quick-pay-modal__body__view_details"
            onClick={this.showErrorDetails}
          >
            View Details
          </button>
        )}
        {detailsShown && <div className="quick-pay-modal__body__error_details">{error}</div>}
      </div>
    );
  }
}

ManualPaymentErrorDetails.propTypes = {
  error: PropTypes.string,
};

ManualPaymentErrorDetails.defaultProps = {
  error: null,
};

export default ManualPaymentErrorDetails;
